import type { HTMLAttributes, ReactNode, Ref } from 'react';

type DependencyContainerProps = {
  children: ReactNode;
  ref?: Ref<HTMLDivElement>;
} & HTMLAttributes<HTMLDivElement>;

export const DependencyContainer = ({ children, ref, ...props }: DependencyContainerProps) => {
  return (
    <div
      className="bg-base-200 border-base-300 border-solid min-h-[400px] w-full rounded-lg flex flex-col overflow-hidden pt-6"
      ref={ref}
      {...props}
    >
      <div className="flex flex-col items-center justify-center w-full m-auto">{children}</div>
    </div>
  );
};
